import CreatingStagingEnvironments from "../../../../src/courses/partials/responsible-development/creating-staging-environments.mdx";
import * as React from 'react';
export default {
  CreatingStagingEnvironments,
  React
};